import React, { useState, useContext, useEffect } from "react";
import {
  BooleanIcon,
  CategoryIcon,
  ChoiceIcon,
  DecimalIcon,
  DeleteIcon,
  FractionIcon,
  IntegerIcon,
  MultiChoiceIcon,
  SubModelIcon,
  TextIcon,
} from "assests/GmsIcons";
import {
  SB3RuleContext
} from "../Rules/SB3RuleContext";
import { OPERATORS } from "./constants";
import { TNode } from "./dataTypes";
import { propertyObj } from "./constants";
import { mapSelectOptions } from "../../helper";
import { getDisplayName, getType } from "./helper";

type LogicRuleSubConditionComponentPropType = {
  data: any;
  index: number;
  type: string;
  rootIndex: number
};




const LogicRuleSubConditionComponent = ({ rootIndex, index, data, type }: LogicRuleSubConditionComponentPropType) => {
  const { modelData, openPickPanel, deleteNodeInLogicalCondtion, updateNodeInLogicalCondtion, selectedObj } = useContext(SB3RuleContext);
  const [linkCss, setLinkCss] = useState('tw-h-12 tw-bg-white')
  useEffect(() => {
    console.log("CHANGE")
    setLinkCss(`tw-h-12 ${(selectedObj?.selectedConditionIndex === index && selectedObj?.selectedRootIndex === rootIndex) ? 'tw-bg-indigo-50' : 'tw-bg-white'}`)

  }, [openPickPanel])
  type PropertyObjKeys = keyof typeof propertyObj;

  return (
    <div className="sub-condition">
      <div className="left-rule-parenthesis" />
      <table className="tw-m-2 tw-w-[500px]">
        <thead className=" tw-h-[35px] tw-w-full tw-pl-4 tw-pr-[60px] tw-py-2 tw-bg-zinc-200 tw-rounded-tl tw-rounded-tr tw-border tw-border-zinc-200 tw-justify-start tw-items-start">
          <tr>
            <th className=" tw-text-slate-500 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-w-[200px]">
              Node
            </th>
            <th className="tw-text-slate-500 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-w-[150px]">
              Property
            </th>
            <th className="tw-text-slate-500 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-w-[75px]">
              Operator
            </th>
            <th className="tw-text-slate-500 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-w-[75px]">
              Value
            </th>
            <th className="tw-text-slate-500 tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-w-[50px]">
            </th>
          </tr>
        </thead>
        <tbody className=" tw-bg-white tw-border tw-border-zinc-200">
          {
            (type === "target" ?
              data :
              data?.rule?.nodes)
              ?.map(
                (node: TNode, nodeIndex: number) => (
                  <tr key={nodeIndex} className={`${nodeIndex % 2 === 0 ? "tw-bg-white" : "tw-bg-gray-100"} `}>
                    <td className="tw-text-wrap tw-flex tw-p-2 tw-mt-2 tw-w-[200px]">
                      <span className={`${(getType(node?.type, node?.field_type) === "choice" || getType(node?.type, node?.field_type) === "product") ? 'tw-m-2' : 'tw-m-1'} tw-mr-2`}>
                        {getType(node?.type, node?.field_type) === "submodel" ? <SubModelIcon /> : null}
                        {getType(node?.type, node?.field_type) === "multi-choice" ? <MultiChoiceIcon /> : null}
                        {getType(node?.type, node?.field_type) === "text" ? <TextIcon /> : null}
                        {getType(node?.type, node?.field_type) === "decimal" ? <DecimalIcon /> : null}
                        {getType(node?.type, node?.field_type) === "fraction" ? <FractionIcon /> : null}
                        {getType(node?.type, node?.field_type) === "integer" ? <IntegerIcon /> : null}
                        {getType(node?.type, node?.field_type) === "boolean" ? <BooleanIcon /> : null}
                        {getType(node?.type, node?.field_type) === "choice" ? <ChoiceIcon /> : null}
                        {getType(node?.type, node?.field_type) === "product" ? <ChoiceIcon /> : null}
                        {getType(node?.type, node?.field_type) === "category" ? <CategoryIcon /> : null}
                      </span>
                      {getDisplayName(node, modelData)}
                    </td>
                    <td className="tw-text-nowrap tw-p-2">
                      <select
                        className="tw-w-[110px] tw-h-9  tw-bg-white tw-rounded tw-border tw-border-zinc-200
                                tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex"
                        onChange={(e) => {
                          updateNodeInLogicalCondtion(rootIndex, index, type, nodeIndex, e?.target?.value, 'property')

                        }}
                        value={node?.property}
                      >
                        {mapSelectOptions(propertyObj[getType(node?.type, node?.field_type) as PropertyObjKeys])}
                      </select>
                    </td>
                    <td className="tw-text-nowrap">
                      {<select
                        className="tw-w-[63px] tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border
                   tw-border-zinc-200 tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex"
                        onChange={(e) => {
                          updateNodeInLogicalCondtion(rootIndex, index, type, nodeIndex, e?.target?.value, 'operator')

                        }}
                        value={node?.operator}
                      >
                        {
                          (node?.property === "logic_state" ? ["=="] : OPERATORS)?.map((x, xIndex) =>
                            <option key={xIndex} value={x}>{x}</option>
                          )
                        }
                      </select>}
                    </td>
                    <td className="tw-text-nowrap">
                      {
                        node?.property === "logic_state" ? <select
                          className="tw-w-[63px] tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border
                       tw-border-zinc-200 tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex"
                          onChange={(e) => {
                            updateNodeInLogicalCondtion(rootIndex, index, type, nodeIndex, e?.target?.value, 'value')

                          }}
                          value={node?.value}
                        >
                          {
                            [0, 1].map((x, xIndex) =>
                              <option key={xIndex} value={x}>{x}</option>
                            )
                          }
                        </select>
                          :
                          <input
                            placeholder="Enter"
                            className=" tw-w-16 tw-h-9 tw-px-2.5 tw-py-2 tw-bg-white tw-rounded tw-border tw-border-zinc-200 tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex"
                            value={node?.value}
                            onChange={(e) => {
                              updateNodeInLogicalCondtion(rootIndex, index, type, nodeIndex, e?.target?.value, 'value')
                            }}
                            disabled={false}
                          />}
                    </td>
                    <td className="tw-text-nowrap">
                      <button className="tw-ml-2 tw-mr-2" onClick={() => {
                        deleteNodeInLogicalCondtion(rootIndex, index, nodeIndex, type)
                      }}>
                        <DeleteIcon />
                      </button>
                    </td>
                  </tr>
                )
              )
          }
          <tr>
            <td className={linkCss}>

              <button onClick={() => openPickPanel(type, index, rootIndex)} className="tw-text-blue-500">Select Node</button>
            </td>
            <td className={linkCss} />
            <td className={linkCss} />
            <td className={linkCss} />
            <td className={linkCss} />
          </tr>
        </tbody>
      </table>
      <div className="right-rule-parenthesis" />
    </div>

  );
};

export default LogicRuleSubConditionComponent;
